<template>
  <div class="feedback">
    <p class="feedback-title">您所搜索不到的信息为：</p>
    <textarea name id cols="30" rows="10" class="feedback-con" v-model="feedBackContent" placeholder="请输入你的搜不到的食物"></textarea>
    <button class="feedback-btn" @click="feedBack">一键反馈</button>
  </div>
</template>
<script>
import { feedBack } from "@/api/eating";
import { Dialog, Notify } from "vant";
export default {
  data() {
    return {
      feedBackContent: ""
    };
  },
  // components: {[Dialog.name]:Dialog},
  methods: {
    async feedBack() {
      const res = await feedBack(this.feedBackContent);
      if (res.code == -16) {
        Notify("请先填内容");
        return;
      }
      if (res.code == 0) {
        Dialog.alert({
          message: "反馈成功！"
        }).then(() => {
          this.feedBackContent = "";
          this.$router.push({
            path: "/eating/list"
          });
        });
      } else {
        Notify(res.message);
      }
    }
  }
};
</script>
<style lang="less">
.feedback {
  padding: 15px 21px;
  &-title {
    color: #222;
    font-size: 14px;
  }
  &-con {
    width: 100%;
    height: 188px;
    background: rgba(239, 239, 244, 1);
    border-radius: 9px;
    border: 0;
    font-size: 12px;
    padding: 10px;
    box-sizing: border-box;
  }
  &-btn {
    position: fixed;
    width: calc(100% - 42px);
    height: 48px;
    line-height: 48px;
    background: #ff789e;
    border-radius: 5px;
    border: 0;
    bottom: 15px;
    left: 21px;
    color: #fff;
    font-size: 14px;
  }
}
</style>

